<div class="intrests-container">
  <div class="container">
    <h1 [@slideInUp]="slideInUp">My intrests</h1>
    <div class="flex-intrest">
      <div [@lightSpeedIn]="lightSpeedIn" class="intrest-primary">
        <div class="intrest">
          <div class="intrest">
            <h3 class="intrest-name">Web Development</h3>
            <mat-slider class="mat-slider intrest-slider cdk-focused" [thumbLabel]="thumbLabel"
              [(ngModel)]="webDevValue">
            </mat-slider>
          </div>
          <h3 class="intrest-name">Machine Learning and AI</h3>
          <mat-slider class="mat-slider intrest-slider cdk-focused" [thumbLabel]="thumbLabel" [(ngModel)]="AIValue">
          </mat-slider>
        </div>
        <div class="intrest">
          <h3 class="intrest-name">Blockchain</h3>
          <mat-slider class="mat-slider intrest-slider cdk-focused" [thumbLabel]="thumbLabel"
            [(ngModel)]="blockChainValue">
          </mat-slider>
        </div>
        <div class="intrest">
          <h3 class="intrest-name">Chess</h3>
          <mat-slider class="mat-slider intrest-slider cdk-focused" [thumbLabel]="thumbLabel" [(ngModel)]="chessValue">
          </mat-slider>
        </div>
      </div>
    </div>
  </div>
</div>
